import { AnyAction } from 'redux';
import { ApplicationState } from 'app/types-store';
import { ComplexValue, ActionDispatching } from 'app/types-shared';
import {
  UpdateSavedFiltersConfig, UpdateFilterValuesTranslation,
  UpdateFilterValues, UpdateFilterMenuValues, ClearAllFilters, OpenCloseFilter,
  UpdateQuery, UpdateQueryValue, SetQueryValues, ClearQuery,
  UpdateFilterValidation
} from './action-types';
import { FilterMenuValues, FilterValidation, FilterCommonValues } from './filters/types';
import { FilterCommonTypes, SearchFiltersConfig } from './types-store';
import { FilterValues } from './types';

export const actionCreators = {

  updateSavedFiltersConfig: (filtersConfig: SearchFiltersConfig): ActionDispatching<AnyAction, ApplicationState> =>
    (dispatch, getState) => {

      dispatch(new UpdateSavedFiltersConfig(filtersConfig));
    },

  updateFilterValuesTranslation: (filterValues: FilterValues): ActionDispatching<AnyAction, ApplicationState> =>
    (dispatch, getState) => {

      dispatch(new UpdateFilterValuesTranslation(filterValues));
    },

  updateFilterValues: (id: string, values: FilterCommonValues<FilterCommonTypes>[]): ActionDispatching<AnyAction, ApplicationState> =>
    (dispatch, getState) => {

      dispatch(new UpdateFilterValues(id, values));
    },

  updateFilterMenuValues: (id: string, values: FilterMenuValues): ActionDispatching<AnyAction, ApplicationState> =>
    (dispatch, getState) => {

      dispatch(new UpdateFilterMenuValues(id, values));
    },

  updateFilterValidation: (filterValidation: FilterValidation): ActionDispatching<AnyAction, ApplicationState> =>
    (dispatch, getState) => {

      dispatch(new UpdateFilterValidation(filterValidation));
    },

  clearAllFilters: (initDefaultFiltersValues: FilterValues): ActionDispatching<AnyAction, ApplicationState> =>
    (dispatch, getState) => {

      dispatch(new ClearAllFilters(initDefaultFiltersValues));
    },

  openCloseFilter: (id: string, open: boolean): ActionDispatching<AnyAction, ApplicationState> =>
    (dispatch, getState) => {

      dispatch(new OpenCloseFilter(id, open));
    },

  updateQuery: (query: string): ActionDispatching<AnyAction, ApplicationState> =>
    (dispatch, getState) => {

      dispatch(new UpdateQuery(query));
    },

  updateQueryValue: (value: ComplexValue<number | string>): ActionDispatching<AnyAction, ApplicationState> =>
    (dispatch, getState) => {

      dispatch(new UpdateQueryValue(value));
    },

  setQueryValues: (values: ComplexValue<number | string>[]): ActionDispatching<AnyAction, ApplicationState> =>
    (dispatch, getState) => {

      dispatch(new SetQueryValues(values));
    },

  clearQuery: (): ActionDispatching<AnyAction, ApplicationState> =>
    (dispatch, getState) => {

      dispatch(new ClearQuery());
    }
};
